import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pgy9sh2kad: FaireBrandEntity = {
  token: "b_pgy9sh2kad",
  type: "brand",
  name: "Corpse Reviver",
  avatarUrl:
    "https://cdn.faire.com/fastly/03dd0cbe2cf4058e6d396d7c7451656ea444d8b0b3c7f72dd78738f683016772.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3c0978dddbf80d706312c2dad83acee75a78f84229b61d33dae47f37967a6053.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/03dd0cbe2cf4058e6d396d7c7451656ea444d8b0b3c7f72dd78738f683016772.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3c0978dddbf80d706312c2dad83acee75a78f84229b61d33dae47f37967a6053.jpeg",
  location: "Denver, CO, USA",
  minimumOrderDollars: 40,
  rating: 5,
  reviewCount: 21,
  isInsider: true,
  description:
    "Welcome to Corpse Reviver, where the art of hydration is elevated to a symphony of well-being crafted by Better Buzz Brands. Our meticulously crafted libations transcend the ordinary, offering you a refreshing journey beyond expectations. At the heart of our beverage is a unique blend of essential elements, including magnesium, potassium, sodium, l-theanine, and zinc. These carefully selected components work in harmony, creating a holistic replenishment experience designed to bring your body back to life.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:45.451Z",
    importedBy: "entity-db-cli",
  },
};
